import { Alert } from '@mui/material';
import {
  CustomAutoComplete,
  CustomButton,
  CustomTextArea,
  CustomTextField,
  DrawerFormSection,
} from '../../../common/components';
import { AUTOCOMPLETE_LISTBOX_PROPS, drawerFieldSpan } from '../../../common/styles';
import {
  INTERNAL_MATERIAL_PURPOSES,
  INTERNAL_MATERIAL_PURPOSE_OPTIONS,
} from '../../constants/internalMaterialPurposes';
import {
  SUPPLY_DESTINATION_KINDS as KINDS,
  SUPPLY_DESTINATION_OPTIONS,
  SUPPLY_DESTINATION_TEXTS as TEXTS,
} from '../constants/supplyOrderDestinationConstants';
import { toProjectOptions } from '../../utils/toProjectOptions';

/** Imputación manual; los destinos derivados de PT se muestran en solo lectura. */
const SupplyOrderDestinationFields = ({
  selectedOrder,
  onChange,
  projects = [],
  projectsLoading = false,
  projectsError,
  onRetryProjects,
  errors = {},
  disabled = false,
}) => (
  <DrawerFormSection title={TEXTS.title} sx={{ mx: 0 }}>
    {selectedOrder.has_technical_origins ? (
      <CustomTextField
        label={TEXTS.technicalDestinations}
        value={selectedOrder.technical_destination_label || ''}
        disabled
        sx={drawerFieldSpan(12)}
      />
    ) : (
      <>
        <CustomAutoComplete
          label={TEXTS.kind}
          name="destination_kind"
          value={selectedOrder.destination_kind || ''}
          options={SUPPLY_DESTINATION_OPTIONS}
          onChange={onChange}
          required
          disabled={disabled}
          error={Boolean(errors.destination_kind)}
          helperText={errors.destination_kind}
          sx={drawerFieldSpan(4)}
        />
        {selectedOrder.destination_kind === KINDS.PROJECT && (
          <CustomAutoComplete
            label={TEXTS.project}
            name="uuid_project"
            value={selectedOrder.uuid_project || ''}
            options={toProjectOptions(projects)}
            inputPlaceholder={TEXTS.searchProject}
            ListboxProps={AUTOCOMPLETE_LISTBOX_PROPS}
            loading={projectsLoading}
            onChange={onChange}
            required
            disabled={disabled}
            error={Boolean(errors.uuid_project)}
            helperText={errors.uuid_project}
            sx={drawerFieldSpan(8)}
          />
        )}
        {selectedOrder.destination_kind === KINDS.PROJECT && projectsError && (
          <Alert
            severity="error"
            sx={drawerFieldSpan(12)}
            action={
              <CustomButton variant="outlined" onClick={onRetryProjects}>
                {TEXTS.retry}
              </CustomButton>
            }
          >
            {projectsError.response?.data?.message || TEXTS.projectLoadError}
          </Alert>
        )}
        {selectedOrder.destination_kind === KINDS.INTERNAL && (
          <CustomAutoComplete
            label={TEXTS.reason}
            name="internal_reason"
            value={selectedOrder.internal_reason || ''}
            options={INTERNAL_MATERIAL_PURPOSE_OPTIONS}
            onChange={onChange}
            required
            disabled={disabled}
            error={Boolean(errors.internal_reason)}
            helperText={errors.internal_reason}
            sx={drawerFieldSpan(8)}
          />
        )}
        {selectedOrder.destination_kind === KINDS.INTERNAL
          && selectedOrder.internal_reason === INTERNAL_MATERIAL_PURPOSES.OTHER && (
          <CustomTextArea
            label={TEXTS.reasonDetail}
            name="internal_reason_detail"
            value={selectedOrder.internal_reason_detail || ''}
            onChange={onChange}
            minRows={2}
            inputProps={{ maxLength: 1000 }}
            required
            disabled={disabled}
            error={Boolean(errors.internal_reason_detail)}
            helperText={errors.internal_reason_detail}
            sx={drawerFieldSpan(12)}
          />
        )}
      </>
    )}
  </DrawerFormSection>
);

export default SupplyOrderDestinationFields;
